import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SiteListItem } from '@billda/api';
import { SiteListItem as SiteListItemComponent } from '../molecules/SiteListItem';
import { ListViewShell } from '../../../../../shared/components/ui/ListViewShell';

interface SitesListViewProps {
  sites: SiteListItem[];
  loading: boolean;
  onItemClick: (siteId: number) => void;
}

export const SitesListView: React.FC<SitesListViewProps> = ({
  sites,
  loading,
  onItemClick,
}) => {
  return (
    <ListViewShell
      itemCount={sites.length}
      loading={loading}
      emptyMessage="No sites found"
      columnHeaders={
        <>
          <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>
            Name
          </Typography>
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              gap: 2,
              flexShrink: 0,
            }}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ width: 95 }}
            >
              Plots
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ width: 90 }}
            >
              Value
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ width: 110 }}
            >
              Progress
            </Typography>
          </Box>
        </>
      }
    >
      {sites.map(site => (
        <SiteListItemComponent
          key={site.id}
          site={site}
          onClick={onItemClick}
        />
      ))}
    </ListViewShell>
  );
};
